import { Button, Flex, Modal, MotionFlex, Text } from "@engaging-tech/components"
import { AnimatePresence } from "framer-motion"
import React from "react"
import { createPortal } from "react-dom"
import styled from "styled-components"

const appRoot = () => typeof document !== "undefined" && document.getElementById("root")

const PopupBanner = styled(Flex)`
  border-radius: 6px 6px 0px 0px;
`

const DeleteWarningOverlay = ({ showWarningOverlay, setShowWarningOverlay, deleteCallback, id }) => {
  return createPortal(
    <AnimatePresence>
      {showWarningOverlay && (
        <MotionFlex
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.1
          }}
        >
          <Modal
            onToggle={() => setShowWarningOverlay(false)}
            bg="light.0"
            width={1 / 1}
            height="auto"
            maxWidth={580}
            flexDirection="column"
            alignItems="center"
            alignContent="center"
          >
            <PopupBanner
              bg="tertiary.0"
              justifyContent="center"
              alignContent="center"
              alignItems="center"
              width={1 / 1}
              height={60}
            >
              <Text color="primary.0" fontFamily="Tiempos" fontSize={5} width="auto">
                Delete This Job Match
              </Text>
            </PopupBanner>
            <Flex
              justifyContent="space-between"
              mt={5}
              mb={5}
              height="auto"
              width={19 / 20}
              flexDirection="column"
              alignItems="center"
              alignContent="center"
            >
              <Text color="dark.0" fontSize={4} mb={2} mt={2} textAlign="center">
                Are you sure you want to delete this job match?
              </Text>
              <Text color="dark.0" fontSize={4} mb={2} mt={2} textAlign="center">
                This will remove the job role permanently from your list of matches.
              </Text>
            </Flex>
            <Flex width={1 / 1} justifyContent="space-between">
              <Button
                bg="transparent"
                elevation={0}
                width={100}
                onClick={() => setShowWarningOverlay(false)}
                mb={3}
              >
                <Text color="primary.0" fontWeight={700} fontSize={3} m={1}>
                  CANCEL
                </Text>
              </Button>
              <Button
                bg="secondary.0"
                elevation={0}
                width={168}
                onClick={() => {
                  deleteCallback(id)
                  setShowWarningOverlay(false)
                }}
                mb={3}
                mr={3}
              >
                <Text color="primary.0" fontWeight={700} fontSize={3} m={1}>
                  DELETE
                </Text>
              </Button>
            </Flex>
          </Modal>
        </MotionFlex>
      )}
    </AnimatePresence>,
    appRoot()
  )
}

export default DeleteWarningOverlay
